import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { RmpvPecaMensalFiltroComponent } from './rmpv-peca-mensal-filtro/rmpv-peca-mensal-filtro.component';
import { RmpvPecaMensalComponent } from './rmpv-peca-mensal.component';
import { RmpvPecaMensalService } from './service/rmpv-peca-mensal.service';

@NgModule({
  imports: [
    CommonModule,
    ComumModule,
    HttpModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  providers: [
    RmpvPecaMensalService
  ],
  declarations: [
    RmpvPecaMensalComponent,
    RmpvPecaMensalFiltroComponent
  ]
})
export class RmpvPecaMensalModule { }
